<template>
    <div>
        <h2 v-if="faq.title">{{ faq.title }}</h2>
        <v-divider class="mt-4 mb-4"></v-divider>

        <div v-if="loading">
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        </div>

        <v-expansion-panels v-if="faq.items && faq.items.length > 0 && !loading">
            <v-expansion-panel
                v-for="(item,index) in faq.items"
                :key="index"
            >
                <v-expansion-panel-header>
                    {{ item.question }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    {{ item.answer }}
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted } from '@vue/composition-api';

export default defineComponent({
    name: 'Faq',
    props: {
        faq: {
            type:  Object,
            required: true
        },
    },
    setup() {
        const loading = ref(true);

        onMounted(() => {
            init();
        });

        function init() {
            loading.value = false;
        }

        return {
            // Variables
            loading,
            // Functions
        }

    }
});
</script>
